import { useEffect, useState } from "react";

/**
 * Twitch live embed — hostname determined client-side because Twitch requires
 * the `parent` param to match the page's hostname.
 */
export default function TwitchEmbed({ channel, height = 420 }) {
  const [hostname, setHostname] = useState("");

  useEffect(() => {
    setHostname(window.location.hostname);
  }, []);

  if (!hostname) return null;

  const src = `https://player.twitch.tv/?channel=${channel}&parent=${hostname}&autoplay=false&muted=true`;

  return (
    <div
      className="relative w-full overflow-hidden rounded-2xl border border-axe-border bg-axe-surface"
      style={{ height }}
      data-testid="twitch-embed"
    >
      <iframe
        title={`Twitch stream ${channel}`}
        src={src}
        allowFullScreen
        className="absolute inset-0 w-full h-full"
      />
    </div>
  );
}
